import { render } from "./FirstChangePassword.vue?vue&type=template&id=460dc25a&ts=true"
import script from "./FirstChangePassword.vue?vue&type=script&lang=ts"
export * from "./FirstChangePassword.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__